import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'limitToTwoNum' })
export class LimitToTwoNumericPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value === null || value === undefined || value === 0 || value === 0.0) {
      return '0.00';
    }

    // Convert to string with fixed 2 decimal places and remove any non-numeric/period characters
    const formattedValue = value.toFixed(2).replace(/[^\d.]/g, '');
    return formattedValue;
  }
}
